var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment, useRef, useState, } from "react";
import { Tooltip } from "..";
import { v4 as uuidv4 } from "uuid";
export var DropdownDivider = function () { return React.createElement("hr", null); };
export var Dropdown = function (_a) {
    var children = _a.children, ariaLabelledBy = _a.ariaLabelledBy, dropdownRef = _a.dropdownRef, className = _a.className, dataTestId = _a.dataTestId, dataId = _a.dataId, dataHook = _a.dataHook;
    return (React.createElement("ul", { ref: dropdownRef, className: "dropdown-menu ".concat(className !== null && className !== void 0 ? className : ""), role: "menu", "aria-labelledby": ariaLabelledBy, "data-testid": dataTestId, "data-id": dataId, "data-hook": dataHook }, children));
};
export function DropdownOptions(_a) {
    var options = _a.options, id = _a.id, item = _a.item, onChange = _a.onChange;
    var _b = useState(null), hoveredItemIndex = _b[0], setHoveredItemIndex = _b[1];
    var _c = useState(false), openLeft = _c[0], setOpenLeft = _c[1];
    var measured = useRef(false);
    return (React.createElement(Fragment, null, options
        .filter(function (option) { return toCheckIfDisplayed(option, item); })
        .map(function (option, i) {
        if (option.divider) {
            return React.createElement(DropdownDivider, { key: i });
        }
        var listItemClassName = "";
        if (option.sectionHeader) {
            listItemClassName = "dropdown-menu-section-header";
        }
        else if (!option.onClick && !option.link && !option.subItems) {
            listItemClassName = "dropdown-menu-no-link";
        }
        else {
            listItemClassName = "dropdown-menu-link";
        }
        var hasSubItems = option.subItems && option.subItems.length > 0;
        var isHovered = hoveredItemIndex === i;
        var isLeftSubmenu = openLeft || option.submenuDirection === "left";
        var dataAttributes = {
            key: i,
            id: option.id && "".concat(id, "--").concat(option.id),
            className: "".concat(listItemClassName, " ").concat(isHovered ? "dropdown-menu-link--hovered" : ""),
        };
        var dropdownitem = (React.createElement("span", __assign({ style: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }, onKeyPress: item
                ? function (ev) { return onOptionChange(item, option, onChange, ev); }
                : onOptionClick(option), onClick: item
                ? function (ev) { return onOptionChange(item, option, onChange, ev); }
                : onOptionClick(option), role: liRole(option, item), tabIndex: liTabIndex(option, item) }, dataAttributes),
            React.createElement("span", null, option.label),
            React.createElement("span", { style: { display: "flex", alignItems: "center", gap: "8px" } },
                option.extraContext && option.extraContext(item),
                hasSubItems && (React.createElement("span", { className: "glyphicon-pro glyphicon-pro-chevron-".concat(isLeftSubmenu ? "left" : "right"), style: { fontSize: "12px", marginRight: "-8px" } })))));
        if (option.link && !getIsDisabled(option, item)) {
            if (option.link.routerLink) {
                var LinkDropdown = option.link.routerLink;
                dropdownitem = (React.createElement(LinkDropdown, __assign({ to: getOptionLink(option, item), href: getOptionLink(option, item) }, dataAttributes),
                    React.createElement("span", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        } },
                        React.createElement("span", null, option.label),
                        React.createElement("span", { style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            } },
                            option.extraContext && option.extraContext(item),
                            hasSubItems && (React.createElement("span", { className: "glyphicon-pro glyphicon-pro-chevron-".concat(isLeftSubmenu ? "left" : "right"), style: { fontSize: "12px", marginRight: "-8px" } }))))));
            }
            else {
                var target = option.link.newTab ? { target: "_blank" } : {};
                dropdownitem = (React.createElement("a", __assign({ href: getOptionLink(option, item) }, dataAttributes, target),
                    React.createElement("span", { style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                        } },
                        React.createElement("span", null, option.label),
                        React.createElement("span", { style: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            } },
                            option.extraContext && option.extraContext(item),
                            hasSubItems && (React.createElement("span", { className: "glyphicon-pro glyphicon-pro-chevron-".concat(isLeftSubmenu ? "left" : "right"), style: { fontSize: "12px", marginRight: "-8px" } }))))));
            }
        }
        return (React.createElement("li", { key: i, className: "".concat(liClassName(option, item), " ").concat(hasSubItems
                ? "dropdown-submenu ".concat(isLeftSubmenu ? "dropdown-submenu--left" : "")
                : ""), role: "menuitem", "aria-disabled": getIsDisabled(option, item), "data-disabled": getIsDisabled(option, item), "data-testid": option.dataTestId, "data-id": option.dataId, "data-label": option.label, onMouseEnter: function (ev) {
                if (!measured.current) {
                    measured.current = true;
                    var parentMenu = ev.currentTarget.closest(".popper-dropdown-content") ||
                        ev.currentTarget.closest(".dropdown-menu") ||
                        ev.currentTarget.parentElement;
                    if (parentMenu) {
                        var rect = parentMenu.getBoundingClientRect();
                        var spaceOnRight = window.innerWidth - rect.right;
                        if (spaceOnRight < rect.width) {
                            setOpenLeft(true);
                        }
                    }
                }
                setHoveredItemIndex(i);
            }, onMouseLeave: function () { return setHoveredItemIndex(null); } },
            canDisplayTooltip(option, item) ? (React.createElement(Tooltip, { tooltipId: uuidv4(), content: option.tooltip, iconShown: true }, !option.divider && dropdownitem)) : (!option.divider && dropdownitem),
            hasSubItems && isHovered && (React.createElement("ul", { className: "dropdown-menu dropdown-submenu-menu ".concat(isLeftSubmenu ? "dropdown-submenu-menu--left" : "") },
                React.createElement(DropdownOptions, { options: option.subItems, id: "".concat(id, "-sub-").concat(i), item: item, onChange: onChange })))));
    })));
}
var onOptionClick = function (option) {
    return !option.disabled ? option.onClick : undefined;
};
export function canDisplayTooltip(option, item) {
    if (option.tooltipDisplayed && option.tooltipDisplayed(item) === false) {
        return (option === null || option === void 0 ? void 0 : option.tooltip) ? false : true;
    }
    return option === null || option === void 0 ? void 0 : option.tooltip;
}
function onOptionChange(item, option, onChange, ev) {
    if (item) {
        !getIsDisabled(option, item) && onChange && onChange(option, ev, item);
    }
}
function getOptionLink(option, item) {
    var _a, _b, _c;
    if ((_a = option === null || option === void 0 ? void 0 : option.link) === null || _a === void 0 ? void 0 : _a.url) {
        var link = (_b = option === null || option === void 0 ? void 0 : option.link) === null || _b === void 0 ? void 0 : _b.url;
        var linkKey = (_c = option === null || option === void 0 ? void 0 : option.link) === null || _c === void 0 ? void 0 : _c.linkKey;
        if (item && linkKey && item[linkKey]) {
            link = link + (linkKey ? "".concat(item[linkKey]) : "");
        }
        return link;
    }
}
function getIsDisabled(option, item) {
    if (option.disabled === undefined)
        return false;
    if (typeof option.disabled === "boolean")
        return option.disabled;
    return option.disabled(item);
}
function liClassName(option, item) {
    if (getIsDisabled(option, item)) {
        return "disabled";
    }
    return undefined;
}
function liRole(option, item) {
    if (option.sectionHeader) {
        return "presentation";
    }
    if ((!option.onClick && !option.link && !option.subItems) ||
        getIsDisabled(option, item)) {
        return undefined;
    }
    return "link";
}
function liTabIndex(option, item) {
    if (option.divider ||
        option.sectionHeader ||
        (!option.onClick && !option.link && !option.subItems) ||
        getIsDisabled(option, item)) {
        return undefined;
    }
    return 0;
}
export var toCheckIfDisplayed = function (option, item) {
    return option.displayed === undefined
        ? true
        : typeof option.displayed === "boolean"
            ? option.displayed !== false
            : option.displayed(item);
};
